import React from 'react';
import PropTypes from 'prop-types';

const Experiences = ( { data } ) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    return (
        <>
            {data.map((education) => (
                <section key={education.id} className="education-entry">
                    <h3 className="text-5">
                        {`${education.designation} in ${education.designation}`}
                    </h3>
                    <div className="mb-2 text-muted text-2 date-entry">{ `${ education.title } / ` }<span className="text-secondary">{ ( education.current === '1' ) ? `${ education.duration } - Current` : education.duration }</span></div>
                    <div className="text-muted text-2">{education.college}</div>
                    <p className="text-muted">{ education.excerpt }</p>
                    <hr className="my-4" />
                </section>
            ))}
        </>
    );
}

Experiences.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            designation: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            current: PropTypes.string,
            duration: PropTypes.string,
            college: PropTypes.string,
            excerpt: PropTypes.string,
        })
    ).isRequired,
};

export default Experiences